import Link from "next/link";

import { Chip, ScrollableWrapper } from "@chef/components";
import { BRAND_PATHS, language } from "@chef/constants";

interface CategoryListProps {
  categories: { value: string | number; slug: string }[];
  parentPath?: string;
}

export const CategoryList = ({
  categories,
  parentPath = BRAND_PATHS.RECIPE_HUB_PATH,
}: CategoryListProps) => {
  return (
    <ScrollableWrapper
      language={language}
      className="mt-10 "
      leftClassName="bg-gradient-to-r from-background via-background"
      rightClassName="bg-gradient-to-l from-background via-background"
      showGradients
    >
      <ul className="flex gap-2">
        {categories.map((category) => {
          let href: string;

          // Check if path has page number
          const pageMatch = parentPath.match(/\/\d+$/);

          if (pageMatch) {
            href = parentPath.replace(/\/\d+$/, `/${category.slug}`);
          } else {
            href = `${parentPath}/${category.slug}`;
          }

          return (
            <li key={category.slug}>
              <Link href={href}>
                <Chip className="hover:cursor-pointer">{category.value}</Chip>
              </Link>
            </li>
          );
        })}
      </ul>
    </ScrollableWrapper>
  );
};
